import Footer from '@viking-eng/footer';
import MvjPropTypes from '@viking-eng/prop-types';

import footerData from 'common/footer-data';

const PreAuthLayout = ({ children }) => (
  <>
    <div className="app-content container d-flex">{children}</div>
    <Footer {...footerData} />
  </>
);

PreAuthLayout.propTypes = {
  children: MvjPropTypes.jsx.isRequired,
};

export default PreAuthLayout;
